import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { VisualizationFilterSettingsGitModel, VisualizationFilterStoreModel } from './visualization-filter.model';

@Injectable({ providedIn: 'root' })
export class VisualizationFilterGitService extends AbstractFeatureGitService<
  VisualizationFilterStoreModel,
  Y42GitFolders.Visualization
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      errorHandlerService,
      name: Y42FeatureType.VisualizationFilter,
      basePath: getY42GitPath(Y42GitFolders.VisualizationFilter),
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          models: {
            type: {
              fileName: 'settings.json',
              property: 'type',
            },
            datasource_table_path: {
              fileName: 'settings.json',
              property: 'datasource_table_path',
            },
            field_name: {
              fileName: 'settings.json',
              property: 'field_name',
            },
            data_type: {
              fileName: 'settings.json',
              property: 'data_type',
            },
            operations: {
              fileName: 'settings.json',
              property: 'operations',
            },
            options: {
              fileName: 'settings.json',
              property: 'options',
            },
          },
        },
      },
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: VisualizationFilterSettingsGitModel,
          serialize: true,
        },
      },
    });
  }
}
